import * as React from 'react';
import { GridColDef, GridColumns } from '@mui/x-data-grid-pro';
import { TerminalCredential } from 'services/clients/credentials';
import { ActionHandler } from 'pages/Settings/TerminalCredentials/actions';
import { ActionColumn } from './action-column';
import { StatusColumn } from './status-column';

const defaultColumn: Partial<GridColDef<TerminalCredential>> = {
  flex: 1,
  cellClassName: 'p-4',
  headerClassName: 'p-4 bg-white',
};

export const getColumns: (
  onAction: ActionHandler,
  onCreate: (credential: TerminalCredential) => void
) => GridColumns<TerminalCredential> = (onAction, onCreate) => [
  {
    ...defaultColumn,
    field: 'portal',
    headerName: 'Portal',
    renderCell: (params) => {
      const { portal } = params.row;
      return (
        <div className="flex space-x-4 items-center">
          <img
            src={portal.logo}
            alt={portal.displayName}
            className="w-[30px] h-[30px] object-contain rounded bg-white border border-gray-200"
          />
          <h4>
            <a
              href={portal.link}
              target="_blank"
              rel="noreferrer"
              onClick={(e) => e.stopPropagation()}
              className="underline text-blue-900"
            >
              {portal.displayName}
            </a>
          </h4>
        </div>
      );
    },
    valueGetter: (params) => params.row.portal.displayName,
  },
  // Disabling column for demo
  // {
  //   ...defaultColumn,
  //   field: 'terminals',
  //   headerName: 'Terminals',
  //   valueGetter: (params) => params.row.portal.terminals.map((t) => t.name).join(' · '),
  //   sortable: false,
  // },
  {
    ...defaultColumn,
    field: 'login',
    headerName: 'Login',
  },
  {
    ...defaultColumn,
    field: 'status',
    headerName: 'Status',
    renderCell: (params) => <StatusColumn credential={params.row} />,
  },
  {
    ...defaultColumn,
    field: '',
    resizable: false,
    sortable: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    renderCell: (params) => (
      <ActionColumn credential={params.row} onAction={onAction} onCreate={onCreate} />
    ),
  },
];
